import { useCallback as n } from "react";
const i = () => n(async (a) => {
  if ("File" in window && a instanceof File)
    return new Promise((s) => {
      const e = new FileReader();
      e.onloadend = () => s(e?.result?.split(",")[1]), e.readAsDataURL(a);
    });
}, []);
export {
  i as default
};
//# sourceMappingURL=useFileToBase64.js.map
